import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ErrorHandler, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

import { map } from 'rxjs';

import { emailValidator, ValidationErrorDirective } from '@rent2end/shared/forms';
import { LogoComponent } from '@rent2end/ui';
import { TranslationPipe } from '@rent2end/core/translation';
import { windowSizeClasses } from '@rent2end/utils/ui';

import { AuthStore } from '../state/auth.store';
import { SignInProvidersComponent } from './providers/sign-in-providers.component';

@Component({
  selector: 'r2e-sign-in',
  imports: [
    MatButton,
    MatIcon,
    MatIconButton,
    ReactiveFormsModule,
    RouterLink,
    LogoComponent,
    SignInProvidersComponent,
    TranslationPipe,
    ValidationErrorDirective
  ],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign.component.scss',
})
export class SignInComponent {
  private authStore = inject(AuthStore);
  private breakpointObserver = inject(BreakpointObserver);
  private errorHandler = inject(ErrorHandler);

  logoVariant = toSignal(
    this.breakpointObserver
      .observe([windowSizeClasses.compact, windowSizeClasses.medium])
      .pipe(
        map(state => state.matches ? 'vertical-logo' : 'horizontal-logo'),
      ),
    { requireSync: true }
  );
  passwordHidden = signal(true);
  signInForm = new FormGroup({
    email: new FormControl<string>('', { nonNullable: true, validators: [emailValidator, Validators.required] }),
    password: new FormControl<string>('', { nonNullable: true, validators: [Validators.minLength(6), Validators.required] }),
  });

  signIn() {
    if (this.signInForm.valid) {
      const { email, password } = this.signInForm.getRawValue();
      this.authStore.signInWithEmailAndPassword(email, password).catch((error) => this.errorHandler.handleError(error));
    }
  }

  togglePasswordVisibility() {
    this.passwordHidden.update(hidden => !hidden);
  }
}
